import { Navbar, Nav, Container, NavDropdown, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaWhatsapp, FaGlobe, FaSignOutAlt } from 'react-icons/fa';
import logo from '../assets/JDGems_Digital_Logo.png';
import { useTranslation } from 'react-i18next';

const CustomNavbar = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
    // Force a reload to ensure all components update their state
    window.location.reload();
  };

  // Check language, use fallback if needed
  const lang = i18n.language ? i18n.language.split('-')[0].toUpperCase() : 'EN';

  return (
    <Navbar
      expand="lg"
      sticky="top"
      variant="dark"
      className="py-1 navbar-dark"
      style={{
        background: "#0F2854",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
      }}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center gap-3 text-white fw-bold fs-4">
          <img 
            src={logo} 
            alt="JD GEMS Logo" 
            className="logo-white"
            style={{ 
              height: '55px', 
              width: 'auto',
              objectFit: 'contain',
              marginTop: '-2px'
            }} 
          />
          <span className="brand-text" style={{ 
            fontSize: '1.4rem',
            lineHeight: '1'
          }}>{t('common.brandName')}</span>
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0 shadow-none" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto fw-medium align-items-center">            
            <Nav.Link as={Link} to="/" className="px-3 text-white text-uppercase small" style={{ letterSpacing: '1.5px' }}>{t('common.home')}</Nav.Link>
            <Nav.Link as={Link} to="/diamonds" className="px-3 text-white text-uppercase small" style={{ letterSpacing: '1.5px' }}>{t('common.diamonds')}</Nav.Link>
            {token && (
              <Nav.Link as={Link} to="/dashboard" className="px-3 text-white text-uppercase small" style={{ letterSpacing: '1.5px' }}>Dashboard</Nav.Link>
            )}
            <Nav.Link 
              href="https://api.whatsapp.com/send/?phone=+4915202693620&text=Hi%20How%20can%20I%20help%20you?&type=phone_number&app_absent=0" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="px-3 text-white text-uppercase small d-flex align-items-center gap-2" 
              style={{ letterSpacing: '1.5px' }}
            >
              <FaWhatsapp size={16} /> {t('common.contactUs')}
            </Nav.Link>
            
            <div className="ms-lg-3 d-flex align-items-center gap-3">
              <div className="d-flex align-items-center">
                <FaGlobe className="text-white me-1" size={14} />
                <NavDropdown 
                  title={lang}
                  id="language-selector"
                  className="custom-nav-dropdown"
                >
                  <NavDropdown.Item onClick={() => changeLanguage('en')} className="small text-uppercase">English</NavDropdown.Item>
                  <NavDropdown.Item onClick={() => changeLanguage('de')} className="small text-uppercase">Deutsch</NavDropdown.Item>
                  <NavDropdown.Item onClick={() => changeLanguage('fr')} className="small text-uppercase">Français</NavDropdown.Item>
                </NavDropdown>
              </div>

              {token && (
                <Button 
                  variant="outline-light" 
                  size="sm" 
                  onClick={handleLogout}
                  className="d-flex align-items-center gap-2 text-uppercase small py-1 px-3"
                  style={{ borderRadius: '20px', fontSize: '10px', letterSpacing: '1px' }}
                >
                  <FaSignOutAlt size={12} /> {t('common.logout') || 'Logout'}
                </Button>
              )}
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
